const API_IP = process.env.REACT_APP_API_IP || 'localhost';
const API_PORT = process.env.REACT_APP_API_PORT || 3977;
const API_PROTOCOL= process.env.REACT_APP_API_PROTOCOL || 'http';

export const basePath = `${API_PROTOCOL}://${API_IP}:${API_PORT}/api`;
export const apiVersion = "v1";